import {
  UNIT_ABBREVIATIONS
} from "./chunk-AR5GOU5H.jsx";
import {
  LANGUAGE_MAP
} from "./chunk-FFQ3QCTT.jsx";
import {
  __name,
  __spreadValues
} from "./chunk-DVUTYNGK.jsx";

// src/utils/number/number.ts
var toFixedWithPrecision = /* @__PURE__ */ __name((num, precision) => {
  const precisionExp = 10 ** precision;
  return Math.trunc(Math.floor(num * precisionExp)) / precisionExp;
}, "toFixedWithPrecision");
var shortenNumberToUnits = /* @__PURE__ */ __name((num = 0) => {
  if (num < 1e3) return num.toString();
  let truncatedNumber = "";
  for (let i = UNIT_ABBREVIATIONS.length - 1; i >= 0; i--) {
    const truncationSize = 10 ** ((i + 1) * 3);
    if (num >= truncationSize) {
      truncatedNumber = Number(
        toFixedWithPrecision(num / truncationSize, 1)
      ).toLocaleString() + UNIT_ABBREVIATIONS[i];
      break;
    }
  }
  return truncatedNumber.toString();
}, "shortenNumberToUnits");
function roundOffTo(num, roundingFactor) {
  return Math.round(num / roundingFactor) * roundingFactor;
}
__name(roundOffTo, "roundOffTo");
var getLocalizedCount = /* @__PURE__ */ __name((count, lang = "en", options = {}) => {
  const localeEntry = LANGUAGE_MAP[lang] || LANGUAGE_MAP.en;
  const locale = localeEntry.locale;
  const formatter = new Intl.NumberFormat(locale, __spreadValues({
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    useGrouping: true
  }, options));
  return formatter.format(count);
}, "getLocalizedCount");
var truncateNumber = /* @__PURE__ */ __name((num = 0, truncateAfter = 3) => {
  if (num < 10 ** (truncateAfter - 1)) return num.toString();
  let truncatedNumber = num.toString();
  for (let i = UNIT_ABBREVIATIONS.length - 1; i >= 0; i--) {
    const truncationSize = 10 ** ((i + 1) * 3);
    if (num >= truncationSize) {
      truncatedNumber = Number(
        toFixedWithPrecision(num / truncationSize, 1)
      ).toLocaleString() + UNIT_ABBREVIATIONS[i];
      break;
    }
  }
  return truncatedNumber.toString();
}, "truncateNumber");

export {
  shortenNumberToUnits,
  roundOffTo,
  getLocalizedCount,
  truncateNumber
};
